module.exports = "https://static.energy5.com/_next/static/images/appEv-084b9fa8a4375a87041febb044703986.png";